import styled, { keyframes } from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  flex: 1;
`;

const Load = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
`;

const loaderAnimation1 = keyframes`
0% {
  transform: scale(0);
}
100% {
  transform: scale(1);
}
`;
const loaderAnimation2 = keyframes`
0% {
  transform: translate(0, 0);
}
100% {
  transform: translate(24px, 0);
}
`;
const loaderAnimation3 = keyframes`
0% {
  transform: scale(1);
}
100% {
  transform: scale(0);
}
`;

const LoaderBall = styled.div`
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #62acd3;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);

  &:nth-child(1) {
    left: 8px;
    animation: ${loaderAnimation1} 0.6s infinite;
  }
  &:nth-child(2) {
    left: 8px;
    animation: ${loaderAnimation2} 0.6s infinite;
  }
  &:nth-child(3) {
    left: 32px;
    animation: ${loaderAnimation2} 0.6s infinite;
  }
  &:nth-child(4) {
    left: 56px;
    animation: ${loaderAnimation3} 0.6s infinite;
  }
`;

export default function Loader(): JSX.Element {
  return (
    <Container data-testid="loader">
      <Load>
        <LoaderBall data-testid="loader_ball" />
        <LoaderBall data-testid="loader_ball" />
        <LoaderBall data-testid="loader_ball" />
        <LoaderBall data-testid="loader_ball" />
      </Load>
      <p>Loading...</p>
    </Container>
  );
}
